import { AlertTriangle } from "react-feather";

export const SHUTDOWN_CONTACT_EMAIL = "sales@twoloox.de";

export function ShutdownNotice() {
    return (
        <section
            aria-label="Shutdown notice"
            className="relative z-30 flex-none flex flex-wrap items-center gap-5 px-8 py-5 bg-elipse-3 text-bg border-b-4 border-[#C24E00]"
        >
            <AlertTriangle aria-hidden="true" className="flex-none w-11 h-11" strokeWidth={2} />
            <div className="flex flex-col gap-1 min-w-0 grow basis-[480px]">
                <p className="m-0 text-[22px] font-extrabold leading-tight">
                    This system will be permanently shut down on 15 November 2026.
                </p>
                <p className="m-0 text-base font-medium">
                    Please contact twoloox at{" "}
                    <a href={`mailto:${SHUTDOWN_CONTACT_EMAIL}`} className="font-extrabold underline">
                        {SHUTDOWN_CONTACT_EMAIL}
                    </a>{" "}
                    to continue using the twoloox Pandoras Box CMS.
                </p>
            </div>
            <a
                href={`mailto:${SHUTDOWN_CONTACT_EMAIL}`}
                className="flex-none inline-flex items-center min-h-[44px] px-5 rounded-lg bg-bg text-white font-bold no-underline"
            >
                Contact twoloox
            </a>
        </section>
    );
}
